import { TransactionType } from '@seapoint/server/enums';

export const isRefund = (transactionType?: TransactionType): boolean => {
  if (!transactionType) return false;
  return (
    transactionType === TransactionType.REFUND ||
    transactionType === TransactionType.CARD_REFUND ||
    transactionType === TransactionType.CARD_CHARGEBACK
  );
};
